(() => {
  function init(root = document) {
    root.querySelectorAll('[data-bb-gallery]').forEach(gallery => {
      if (gallery.dataset.enhanced) return;
      const source = [...gallery.querySelectorAll('[data-bb-image], [data-bb-video]')];
      const main = gallery.querySelector('.bb-gallery-main');
      if (!main || !source.length || !window.HTMLDialogElement) return;
      gallery.dataset.enhanced = 'true';
      const button = (label, text = label) => {
        const node = document.createElement('button');
        node.type = 'button'; node.setAttribute('aria-label', label); node.textContent = text;
        return node;
      };
      const open = button(gallery.dataset.open);
      open.className = 'bb-gallery-open'; open.setAttribute('aria-haspopup', 'dialog');
      gallery.append(open);
      const hero = button(gallery.dataset.open, ''); hero.className = 'bb-gallery-trigger';
      hero.setAttribute('aria-haspopup', 'dialog'); main.before(hero); hero.append(main);
      const dialog = document.createElement('dialog'); dialog.className = 'bb-media-dialog';
      dialog.setAttribute('aria-label', gallery.dataset.title);
      const header = document.createElement('header');
      const title = document.createElement('h2'); title.textContent = gallery.dataset.title;
      const close = button(gallery.dataset.close, '×'); header.append(title, close);
      const stage = document.createElement('div'); stage.className = 'bb-media-stage';
      const previous = button(gallery.dataset.previous, '‹');
      const next = button(gallery.dataset.next, '›');
      const image = document.createElement('img'); image.alt = main.alt;
      const video = document.createElement('video');
      video.controls = true; video.playsInline = true; video.preload = 'metadata'; video.hidden = true;
      stage.append(previous, image, video, next);
      const status = document.createElement('p'); status.className = 'bb-media-position'; status.setAttribute('aria-live', 'polite');
      const thumbs = document.createElement('div'); thumbs.className = 'bb-media-thumbs';
      let index = 0;
      const selections = source.map((item, i) => {
        const control = button(item.getAttribute('aria-label'), '');
        const thumb = item.querySelector('img')?.cloneNode(true);
        if (thumb) { thumb.alt = ''; control.append(thumb); }
        if (item.dataset.bbVideo) {
          control.className = 'bb-video-thumbnail';
          const icon = document.createElement('span'); icon.textContent = '▶'; icon.setAttribute('aria-hidden', 'true'); control.append(icon);
        }
        control.addEventListener('click', () => select(i));
        thumbs.append(control); return control;
      });
      function select(i) {
        video.pause();
        index = (i + source.length) % source.length;
        const selected = source[index], isVideo = Boolean(selected.dataset.bbVideo);
        image.hidden = isVideo; video.hidden = !isVideo;
        if (isVideo) {
          video.setAttribute('aria-label', selected.getAttribute('aria-label'));
          video.poster = selected.dataset.bbPoster || '';
          if (video.getAttribute('src') !== selected.dataset.bbVideo) video.src = selected.dataset.bbVideo;
        } else image.src = selected.dataset.bbImage;
        status.textContent = `${index + 1} / ${source.length}`;
        selections.forEach((node, n) => node.setAttribute('aria-pressed', String(n === index)));
      }
      dialog.append(header, stage, status, thumbs); gallery.append(dialog);
      let launcher = open;
      const show = (trigger, initial) => {
        launcher = trigger;
        select(initial ?? Math.max(0, source.findIndex(item => item.getAttribute('aria-pressed') === 'true')));
        dialog.showModal();
      };
      open.addEventListener('click', () => show(open));
      hero.addEventListener('click', () => show(hero));
      source.forEach((item, i) => {
        if (item.dataset.bbVideo) item.addEventListener('click', () => show(item, i));
      });
      const hiddenImages = source.filter(item => item.dataset.bbImage).slice(6);
      if (hiddenImages.length) {
        hiddenImages.forEach(item => { item.hidden = true; });
        const more = button(`${gallery.dataset.open} (+${hiddenImages.length})`, `+ ${hiddenImages.length}`);
        more.setAttribute('aria-haspopup', 'dialog'); more.className = 'bb-gallery-more';
        gallery.querySelector('.bb-thumbnails').append(more);
        more.addEventListener('click', () => show(more, source.indexOf(hiddenImages[0])));
      }
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { video.pause(); launcher.focus(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      previous.addEventListener('click', () => select(index - 1));
      next.addEventListener('click', () => select(index + 1));
      dialog.addEventListener('keydown', event => {
        if (event.target === video) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); select(index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
